module.exports = __webpack_public_path__ + "static/media/points8_5.eb81aee4.png";